<table class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th [hidden]="!allowEditTransactions" class="no-sort" ></th>
      <th class="no-sort">
        Date {{ this._sortColumn === 'transactions.create_date' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">
        Card {{ this._sortColumn === 'transaction_types.name' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">
        Expiration {{ this._sortColumn === 'transactions.magnified_amount' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">
        Type {{ this._sortColumn === 'transactions.magnified_amount' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">
        Amount {{ this._sortColumn === 'transactions.magnified_amount' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>
      <th class="no-sort">
        Status {{ this._sortColumn === 'transactions.magnified_amount' ? (this._sortDirection === 'asc' ? '↑' : '↓') : '' }}
      </th>

    </tr>
  </thead>
  <tbody>
    @if (loading) {
      <tr>
        <td colspan="7">
          <div class="cpo-table-loading">
            <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
          </div>
        </td>
      </tr>
    } @else {
      @for (
        item of this.dataSource.data;
        track item.id;
        let even = $even;
        let odd = $odd
      ) {
        @if (item.id != undefined) {
          <tr
            id="trsummary_{{ item.id }}"
            [ngClass]="{ even: even, odd: odd, 'selected': selectedTransactions.includes(item) }"
            class="cpo-selectable-table__row"
          >
            <td [hidden]="!allowEditTransactions">
              <app-checkbox
                style="margin-top: 5px;"
                (change)="onCheckboxChange(item)"
              />
            </td>
            <td>
              <span [innerHTML]="formatDate(item.date, '')"></span>
            </td>
            <td>
              {{ item.cardType }} {{ item.cardFirst6 }}****{{ item.cardLast4 }}
            </td>
            <td>
              {{ item.cardExpMonth }}/{{ item.cardExpYear }}
            </td>
            <td>{{ item.type }}</td>
            <td>{{ item.totalAmount }}</td>
            <td>{{ item.successful ? 'Yes' : 'No' }}</td>
          </tr>
        }
        @if (this.options.selectAction == 'details') {
          <tr
            id="trdetails_{{ item.id }}"
            class="rowDetails noHover"
            style="display: none"
          >
            <td [attr.colspan]="hideMID ? 5 : 6">
              <div style="background-color: #ffffff; padding: 10px">
                <b>Transaction Details</b>
                <input
                  type="button"
                  value="Return"
                  [hidden]="
                    item.batchDate == '' ||
                    item.type != 'CAPTURE' || item.type != 'RECURRING'
                  "
                />
                <input
                  type="button"
                  value="Void"
                  [hidden]="
                    item.batchDate != '' ||
                    (item.type != 'CAPTURE' && item.type != 'RECURRING')
                  "
                />
              </div>
            </td>
          </tr>
        }
      }
    }
  </tbody>
</table>
